module.exports = __webpack_public_path__ + "static/media/Thirsk-Carved-Italic-by-TTF.d2cbe5e2.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Thirsk-Carved-Italic-by-TTF.woff2
// module id = 3792
// module chunks = 68